import { useMutation } from '@tanstack/react-query';
import { getOwnBackend } from '@/app/config/products.config';
import { downloadBlob } from '../../../shared/utils/download-blob.util';
import { toaster } from '../../../shared/ui/toaster.component';

export type OwnBackendPolicyPdfParams = {
  productCode: string | undefined;
  id: string;
};

/**
 * Download do PDF da apólice de produto com backend próprio (ex.: RD
 * Equipamentos) — paridade com o "Baixar PDF Apólice" dos demais produtos
 * (`useStarterKit`/`useDocumentPdf`): o binário vem de
 * `ownBackend.fetchPolicyPdf` do registry e é salvo com o nome vindo do
 * `Content-Disposition` (ex.: `apolice-<número>.pdf`).
 */
export function useOwnBackendPolicyPdf() {
  return useMutation({
    retry: false,
    mutationFn: async ({ productCode, id }: OwnBackendPolicyPdfParams) => {
      const ownBackend = getOwnBackend(productCode);
      if (!ownBackend) {
        throw new Error(`Produto ${productCode} não tem backend próprio.`);
      }
      const { blob, filename } = await ownBackend.fetchPolicyPdf(id);
      downloadBlob(blob, filename);
    },
    onError: (error: unknown) => {
      // O motivo vem do servidor quando existe. O texto fixo anterior
      // ("a apólice fica disponível depois da emissão") aparecia até em
      // apólice JÁ EMITIDA, quando a causa era outra — o corretor lia
      // aquilo e concluía que a emissão tinha falhado.
      const motivo =
        error instanceof Error && error.message.trim()
          ? error.message.trim()
          : 'Tente novamente em instantes.';
      toaster.create({
        type: 'error',
        title: 'Não foi possível baixar o PDF',
        description: motivo,
      });
    },
  });
}
